import React, { useState, useEffect, useRef } from "react";
import "./invoice.css";
import logo from "../../../Assets/jklogo.png";
import logo1 from "../../../Assets/jk.png"
import Sign from "../../../Assets/DirectorSign.png";
import Sign1 from "../../../Assets/DirectorSign1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import QRCode from "qrcode";
import PdfPreview from "../../../Common/PDFPreview";
import { ConvertNumberToWord } from "../../../Common/FormatFunctions/ConvertNumberToWord";
import PrintButton from "../../../Common/Buttons/PrintPDF";
import Santlogo from "../../../Assets/jk.png"
import HeaderJK from "../../../Assets/HeaderJK.png";
import FooterJK from "../../../Assets/FooterJK.png";
import FooterJK1 from "../../../Assets/FooterJK1.png";
import "../../../Common/Fonts/Signika-Bold-normal";
import "../../../Common/Fonts/Signika-Regular-normal";
import "../../../Common/Fonts/Signika-Medium-normal";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";

const API_URL = process.env.REACT_APP_API;

const GulCustomizeSBBatchReport = ({ doc_no, disabledFeild }) => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const [invoiceData, setInvoiceData] = useState([]);
    const [pdfPreview, setPdfPreview] = useState(null);
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
    const newCompanyName = sessionStorage.getItem("newCompanyName")
    const oldFormerlyName = sessionStorage.getItem("oldFormerlyName")
    const [showBatchPopup, setShowBatchPopup] = useState(false);
    const [fromDocNo, setFromDocNo] = useState("");
    const [toDocNo, setToDocNo] = useState("");


    const fetchData = async () => {
        try {
            const response = await fetch(
                `${API_URL}/generating_gullsaleBill_batchprint_report?Company_Code=${companyCode}&Year_Code=${Year_Code}&FromDoc_No=${fromDocNo}&ToDoc_No=${toDocNo}`
            );
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const data = await response.json();

            setInvoiceData(data.all_data);
            generatePdf(data.all_data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const generatePdf = async (data) => {

        const pdf = new jsPDF({ orientation: "portrait" });
        const allData = Array.isArray(data) ? data : [];

        const groupedData = {};

        allData.forEach(row => {
            if (!groupedData[row.doc_no]) {
                groupedData[row.doc_no] = [];
            }
            groupedData[row.doc_no].push(row);
        });



        const groupedDocs = Object.keys(groupedData);

        const docDate = new Date(allData.doc_date);
        const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

        for (let i = 0; i < groupedDocs.length; i++) {


            const docNo = groupedDocs[i];
            const billData = groupedData[docNo];
            const rowData = billData[0];

            if (i !== 0) {
                pdf.addPage();
            }

            // let billRows = groupedData[groupedDocs[i]];
            // let rowData = billRows[0];



            const displayCompanyName =
                docDate < cnameUpdatedDate
                    ? newCompanyName
                    : rowData.Company_Name_E;


            const logoToUse = docDate < cnameUpdatedDate ? Santlogo : Santlogo;
            const SignToUse = docDate < cnameUpdatedDate ? Sign1 : Sign;
            const foormerlyName = docDate < cnameUpdatedDate ? oldFormerlyName : rowData.AL1;

            pdf.setFont("Signika-Regular");
            pdf.setFontSize(8);

            const logoImg = new Image();
            // const signImg = new Image();
            // const headerImg = new Image();
            // const footerImg = new Image();
            // const footerImg1 = new Image();
            logoImg.src = Santlogo;
            // signImg.src = SignToUse;
            // headerImg.src = HeaderJK;
            // footerImg.src = FooterJK;
            // footerImg1.src = FooterJK1

            // const qrCodeData = `
            // GSTN of Supplier : ${rowData.companyGSTNo || ""}
            // GSTIN of Buyer : ${allData.billtogstno || ""}
            // Document No. : ${allData.doc_no || ""}
            // Document Type : Tax Invoice
            // Date : ${allData.doc_date || ""}
            // HSN : ${allData.HSN || ""}
            // IRN : ${allData.einvoiceno || ""}
            // `;
            // const qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());

            let qrCodeDataUrl = null;





            if (rowData.companyGSTNo?.trim()) {
                const qrCodeData = `
                GSTN of Supplier : ${rowData.companyGSTNo}
                GSTIN of Buyer : ${rowData.billtogstno || ""}
                Document No. : ${rowData.doc_no || ""}
                Document Type : Tax Invoice
                Date : ${rowData.doc_date || ""}
                HSN : ${rowData.HSN || ""}
                IRN : ${rowData.einvoiceno || ""}
            `;

                qrCodeDataUrl = await QRCode.toDataURL(qrCodeData.trim());
            }

            logoImg.src = logoToUse;
            await new Promise((resolve) => {
                logoImg.onload = resolve;
            });

            if (logoImg) {


                let startY = 18;
                const lineHeight = 4;
                const maxWidth = 120; // adjust based on layout

                const drawTextBlock = (text) => {
                    if (!text) return;
                    const lines = pdf.splitTextToSize(String(text), maxWidth);
                    lines.forEach((line) => {
                        pdf.text(line, 45, startY);
                        startY += lineHeight;
                    });
                };

                const shouldUseImage =
                    docDate >= cnameUpdatedDate

                //     pdf.addImage(logoImg, "PNG", 12, 2, 25, 25);
                // pdf.setFont("Signika-Bold");

                pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                pdf.setFont("Signika-Bold");
                pdf.setFontSize(14);
                pdf.text(displayCompanyName, 45, 14);
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(9);
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(9);
                drawTextBlock(`${foormerlyName}`, 45, 18);
                drawTextBlock(`${rowData.AL2}`, 45, 22);
                // pdf.text(`${rowData.AL3}`, 45, 26);
                drawTextBlock(`${rowData.AL4}`, 45, 26);
                drawTextBlock(`${rowData.Other || ""}`, 45, 30);
                // pdf.text(`${allData.BillFooter}`,45,38)
                // if (shouldUseImage) {
                //     // Use header image across top (new template)
                //     // pdf.addImage(headerImg, "PNG", 0, 6, 180, 34); // full width
                // } else {
                //     // Old layout: logo + company name + address lines
                //     pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                //     pdf.setFont("Signika-Bold");
                //     pdf.setFontSize(14);
                //     pdf.text(displayCompanyName, 45, 14);
                //     pdf.setFont("Signika-Regular");
                //     pdf.setFontSize(9);
                //     pdf.text(`${foormerlyName}`, 45, 18);
                //     pdf.text(`${rowData.AL2}`, 45, 22);
                //     // pdf.text(`${rowData.AL3}`, 45, 26);
                //     pdf.text(`${rowData.AL4}`, 45, 30);
                //     pdf.text(`${rowData.Other}`, 45, 34);
                //     // pdf.text(`${rowData.BillFooter}`, 45, 38);
                // }
                if (qrCodeDataUrl) {
                    pdf.addImage(qrCodeDataUrl, "PNG", 170, 9, 30, 30);
                }
                // pdf.text(`${allData.Carporate_Address}`, 105, 12, { align: "center" });
                // ======= CUSTOM HEADER WITHOUT IMAGE =======
                pdf.setFont("Signika-Medium");
                pdf.setFontSize(16);
                pdf.setTextColor(0, 0, 0);


                // Center the text header
                // pdf.text(`${allData.Company_Name_E}`, 105, 18, { align: "center" });

                // Optional: small subtitle
                pdf.setFont("Signika-Regular");
                pdf.setFontSize(10);


                pdf.setFontSize(10);
                pdf.setFont("Signika-Bold");
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, 44, 200, 44);
                pdf.setTextColor(41, 122, 14);
                pdf.text("TAX INVOICE", 95, 49);
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, 52, 200, 52);
                pdf.setTextColor(0, 0, 0);

                let y = 45;
                pdf.setFontSize(9);

                const fieldPairs = [
                    [
                        `Invoice No. :  SJ${rowData.year}-${rowData.doc_no}`,
                        `Invoice Date : ${rowData.doc_dateConverted}`,
                        "Lorry No.",
                        rowData.LORRYNO,
                    ],
                    [
                        `DO No. : ${rowData.DO_No}`,
                        `Date of Supply : ${rowData.doc_dateConverted}`,
                        "Transport Mode",
                        "Road",
                    ],
                    [
                        `E-Way Bill No.: ${rowData.EWay_Bill_No}`,
                        `EwayBill ValidDate: ${rowData.EwayBillValidDate}`,
                        "From",
                        `${rowData.millshortname} (${rowData.millstatename} - ${rowData.millstatecode})`,
                    ],
                    [
                        `Acknowledge: ${rowData.ackno}`,
                        "",
                        "Place Of Supply",
                        `${rowData.shiptocityname} (${rowData.shiptocitystate} - ${rowData.shiptogststatecode})`,
                    ],
                    [
                        `E-Invoice No.: ${rowData.einvoiceno}`,
                        "",
                        "Ref By",
                        rowData.shiptoshortname,
                    ],
                    ["", "", "Reverse Charge", "No"],
                ];

                fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {
                    const leftX = 12;
                    const middleX = 60;
                    const rightX = 110;
                    const wrapWidth = 85;
                    const lineHeight = 4;

                    const [rawLeftLabel, ...rawLeftValParts] = (left1 ?? "").split(":");
                    const leftLabel = rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}:` : "";
                    const leftValue = rawLeftValParts.join(":").trim();
                    const leftValueLines = pdf.splitTextToSize(leftValue, wrapWidth - pdf.getTextWidth(leftLabel));

                    const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                    const rightLabelText = rightLabel?.trim() ? `${rightLabel.trim()}:` : "";
                    const rightValueText = rightValue?.toString().trim() ?? "";
                    const rightValueLines = pdf.splitTextToSize(rightValueText, wrapWidth - pdf.getTextWidth(rightLabelText));

                    const maxLines = Math.max(leftValueLines.length, left2Lines.length, rightValueLines.length);

                    for (let i = 0; i < maxLines; i++) {
                        const yOffset = y + i * lineHeight + 17;

                        if (i === 0 && leftLabel) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(leftLabel, leftX, yOffset);
                            pdf.setFont("Signika-Regular");
                            pdf.text(leftValueLines[i] ?? "", leftX + pdf.getTextWidth(leftLabel) + 1, yOffset);
                        } else if (leftValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(leftValueLines[i], leftX, yOffset);
                        }


                        if (left2Lines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(left2Lines[i], middleX, yOffset);
                        }

                        if (i === 0 && rightLabelText) {
                            pdf.setFont("Signika-Medium");
                            pdf.text(rightLabelText, rightX, yOffset);
                            pdf.setFont("Signika-Regular");
                            pdf.text(rightValueLines[i] ?? "", rightX + pdf.getTextWidth(rightLabelText) + 1, yOffset);
                        } else if (rightValueLines[i]) {
                            pdf.setFont("Signika-Regular");
                            pdf.text(rightValueLines[i], rightX, yOffset);
                        }
                    }

                    y += maxLines * lineHeight;
                });


                const drawFieldPairs = () => {
                    const fieldPairs = [
                        [
                            `Invoice No. :  SJ${rowData.year}-${rowData.doc_no}`,
                            `Invoice Date : ${rowData.doc_dateConverted}`,
                            "Lorry No.",
                            rowData.LORRYNO,
                        ],
                        [
                            `DO No. : ${rowData.DO_No}`,
                            `Date of Supply : ${rowData.doc_dateConverted}`,
                            "Transport Mode",
                            "Road",
                        ],
                        [
                            `E-Way Bill No.: ${rowData.EWay_Bill_No}`,
                            `EwayBill ValidDate: ${rowData.EwayBillValidDate}`,
                            "From",
                            `${rowData.millshortname} (${rowData.millstatename} - ${rowData.millstatecode})`,
                        ],
                        [
                            `Acknowledge: ${rowData.ackno}`,
                            "",
                            "Place Of Supply",
                            `${rowData.shiptocityname} (${rowData.shiptocitystate} - ${rowData.shiptogststatecode})`,
                        ],
                        [
                            `E-Invoice No.: ${rowData.einvoiceno}`,
                            "",
                            "Ref By",
                            rowData.shiptoshortname,
                        ],
                        ["", "", "Reverse Charge", "No"],
                    ];

                    fieldPairs.forEach(([left1, left2, rightLabel, rightValue]) => {
                        const leftX = 12;
                        const middleX = 60;
                        const rightX = 110;
                        const wrapWidth = 85;
                        const lineHeight = 4;

                        const [rawLeftLabel, ...rawLeftValParts] = (left1 ?? "").split(":");
                        const leftLabel = rawLeftLabel?.trim() ? `${rawLeftLabel.trim()}:` : "";
                        const leftValue = rawLeftValParts.join(":").trim();
                        const leftValueLines = pdf.splitTextToSize(leftValue, wrapWidth - pdf.getTextWidth(leftLabel));

                        const left2Lines = pdf.splitTextToSize(left2 ?? "", wrapWidth);

                        const rightLabelText = rightLabel?.trim() ? `${rightLabel.trim()}:` : "";
                        const rightValueText = rightValue?.toString().trim() ?? "";
                        const rightValueLines = pdf.splitTextToSize(rightValueText, wrapWidth - pdf.getTextWidth(rightLabelText));

                        const maxLines = Math.max(leftValueLines.length, left2Lines.length, rightValueLines.length);

                        for (let i = 0; i < maxLines; i++) {
                            const yOffset = y + i * lineHeight + 17;

                            if (i === 0 && leftLabel) {
                                pdf.setFont("Signika-Medium");
                                pdf.text(leftLabel, leftX, yOffset);
                                pdf.setFont("Signika-Regular");
                                pdf.text(leftValueLines[i] ?? "", leftX + pdf.getTextWidth(leftLabel) + 1, yOffset);
                            } else if (leftValueLines[i]) {
                                pdf.setFont("Signika-Regular");
                                pdf.text(leftValueLines[i], leftX, yOffset);
                            }


                            if (left2Lines[i]) {
                                pdf.setFont("Signika-Regular");
                                pdf.text(left2Lines[i], middleX, yOffset);
                            }

                            if (i === 0 && rightLabelText) {
                                pdf.setFont("Signika-Medium");
                                pdf.text(rightLabelText, rightX, yOffset);
                                pdf.setFont("Signika-Regular");
                                pdf.text(rightValueLines[i] ?? "", rightX + pdf.getTextWidth(rightLabelText) + 1, yOffset);
                            } else if (rightValueLines[i]) {
                                pdf.setFont("Signika-Regular");
                                pdf.text(rightValueLines[i], rightX, yOffset);
                            }
                        }

                        y += maxLines * lineHeight;
                    });

                    return y;
                };

                const verticalX = 105;
                const topOfFieldPairs = 59;
                const bottomOfFieldPairs = y + 12;

                pdf.setDrawColor(80, 80, 80);
                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(verticalX, topOfFieldPairs, verticalX, bottomOfFieldPairs);

                // const addressBlock = (x, yStart, title, lines) => {
                //   let y = yStart;
                //   let lineHeight = 4;
                //   pdf.setFont("Signika-Regular");
                //   pdf.setTextColor(41, 122, 14);
                //   pdf.text(title, x, y);
                //   y += lineHeight;

                //   lines.forEach((line, index) => {
                //     const wrapped = pdf.splitTextToSize(String(line ?? ""), 85);
                //     pdf.setFont(index === 0 ? "Signika-Bold" : "Signika-Regular");
                //     if (index === 0) {
                //       pdf.setTextColor(41, 122, 14);
                //     } else {
                //       pdf.setTextColor(0, 0, 0);
                //     }

                //     pdf.text(wrapped, x, y);
                //     y += wrapped.length * lineHeight;
                //   });
                //   return y;
                // };

                //uniform Spacing
                const addressBlock = (x, yStart, title, lines) => {
                    let y = yStart;
                    const lineHeight = 4; // same as other blocks

                    // Title
                    pdf.setFont("Signika-Medium");
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(title, x, y + 10);
                    y += lineHeight;

                    // Body lines
                    lines.forEach((line, index) => {
                        const wrapped = pdf.splitTextToSize(String(line ?? ""), 85);

                        // First line: bold and green, rest normal
                        pdf.setFont(index === 0 ? "Signika-Bold" : "Signika-Regular");
                        pdf.setTextColor(index === 0 ? 41 : 0, index === 0 ? 122 : 0, index === 0 ? 14 : 0);

                        // Loop through each wrapped line to draw and increment y
                        wrapped.forEach((wLine) => {
                            pdf.text(wLine, x, y + 10);
                            y += lineHeight; // uniform spacing
                        });
                    });

                    return y; // returns new y-position to continue below this block
                };


                const isRegular =
                    rowData.carporateSaleDoc !== 0 &&
                    rowData.carporateSaleDoc !== "" &&
                    rowData.selling_type === "P" &&
                    rowData.Delivery_type === "C";

                const fssaiNo = isRegular
                    ? rowData.FSSAI_BillTo
                    : rowData.carporateBillToFSSAI || rowData.FSSAI_BillTo;

                const tanNo = isRegular
                    ? rowData.BillToTanNo
                    : rowData.Carporate_Tanno || rowData.BillToTanNo;

                const billToLines = [
                    isRegular
                        ? rowData.billtoname
                        : rowData.CarporateBillTo_Name || rowData.billtoname,

                    isRegular
                        ? `${rowData.billtoaddress}, ${rowData.billtocitystate} ${rowData.billtopincode}`
                        : `${rowData.Carporate_Address}, ${rowData.carporateBillToStateName} ${rowData.carporateBillToPincode}` ||
                        `${rowData.billtoaddress}, ${rowData.billtocitystate} ${rowData.billtopincode}`,

                    `City: ${isRegular
                        ? `${rowData.billtopin} (${rowData.billtocitystate} - ${rowData.billtogststatecode})`
                        : rowData.carporateBillToCityName
                            ? `${rowData.carporateBillToCityName}  (${rowData.carporateBillToStateName} - ${rowData.CarporateState_Code})`
                            : `${rowData.billtopin} (${rowData.billtocitystate} - ${rowData.billtogststatecode})`
                    }`,
                    `GST: ${isRegular
                        ? rowData.billtogstno
                        : rowData.CarporateBillToGst_No || rowData.billtogstno
                    }`,

                    `PAN: ${isRegular
                        ? rowData.billtopanno
                        : rowData.Carporate_Pan || rowData.billtopanno
                    }`,

                    fssaiNo ? `FSSAI: ${fssaiNo}` : null,
                    tanNo ? `TAN: ${tanNo}` : null,
                ].filter(Boolean);

                const fssaiShipTo = rowData.FSSAI_ShipTo;
                const tanShipTo = rowData.ShipToTanNo;

                const shipToLines = [
                    rowData.shiptoname,
                    rowData.shiptoaddress,
                    `City: ${rowData.shiptocityname} (${rowData.shiptocitystate} - ${rowData.shiptogststatecode})`,
                    `GST: ${rowData.shiptogstno}`,
                    `PAN: ${rowData.shiptopanno}`,
                    fssaiShipTo ? `FSSAI: ${fssaiShipTo}` : null,
                    tanShipTo ? `TAN: ${tanShipTo}` : null,
                ].filter(Boolean); // removes null/undefined/empty


                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, y + 18, 200, y + 18);

                const addressStartY = y + 17;
                // setTextColor(0, 0, 0)
                const endYBill = addressBlock(12, addressStartY, "Buyer (Bill to):", billToLines);
                const endYShip = addressBlock(110, addressStartY, "Consignee (Ship to):", shipToLines);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(105, addressStartY + 6, 105, Math.max(endYBill, endYShip) + 7);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(
                    10,
                    Math.max(endYBill, endYShip) + 13,
                    200,
                    Math.max(endYBill, endYShip) + 13
                );
                y = Math.max(endYBill, endYShip) + 11;

                const verticalStartAfterGap = addressStartY + 15;
                const verticalEnd = Math.max(endYBill, endYShip);
                pdf.setDrawColor(80, 80, 80);
                // pdf.line(105, verticalStartAfterGap + 50, 105, verticalEnd + 8);


                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.setFont("Signika-Medium");

                const rawUnit = rowData.unit ? rowData.unit.trim() : "";
                const unitUpper = rawUnit.toUpperCase();

                // const headerText =
                //   unitUpper === "QTL" ? "Quintal" :
                //   unitUpper === "KGS" ? "Unit" :
                //   "Unit";  // default

                // pdf.text(headerText, 140, y + 7);


                pdf.setTextColor(41, 122, 14);
                pdf.text("Particulars", 12, y + 7);
                // pdf.text("Short Name", 50, y + 7, { align: "left" });
                pdf.text("HSN", 80, y + 7);
                pdf.text("Quantity", 100, y + 7);
                // pdf.text("Season", 120, y + 7);
                // pdf.text(rawUnit.toUpperCase() === "QTL" ? "Quintal" : "Unit", 140, y + 7);
                pdf.text("Weight", 130, y + 7);
                pdf.text("Rate", 160, y + 7);
                pdf.text("Value", 182, y + 7);
                y += 5;

                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, y + 5, 200, y + 5);



                const addHeader = (pdf) => {
                    pdf.addImage(logoImg, "PNG", 10, 9, 30, 30);
                    pdf.setTextColor(0, 0, 0);
                    pdf.setFont("Signika-Bold");
                    pdf.setFontSize(14);
                    pdf.text(displayCompanyName, 45, 14);
                    pdf.setFont("Signika-Regular");
                    pdf.setFontSize(9);
                    pdf.text(`${foormerlyName}`, 45, 18);
                    pdf.text(`${rowData.AL2}`, 45, 22);
                    // pdf.text(`${rowData.AL3}`, 45, 26);
                    pdf.text(`${rowData.AL4}`, 45, 26);
                    pdf.text(`${rowData.Other}`, 45, 30);
                    // pdf.text(`${rowData.BillFooter}`, 45, 38);
                    // pdf.text("By Laws No 18 & 52, Schedule No 18 Bill", 105, 12, { align: "center" });
                    // ======= CUSTOM HEADER WITHOUT IMAGE =======
                    pdf.setFont("Signika-Medium");
                    pdf.setFontSize(16);
                    pdf.setTextColor(0, 0, 0);


                    // Center the text header
                    // pdf.text("Sangli Krushi Utappan Bazar Samiti , Sangli", 105, 18, { align: "center" });

                    // Optional: small subtitle
                    pdf.setFontSize(10);
                    pdf.setFont("Signika-Bold");
                    pdf.setDrawColor(80, 80, 80);
                    pdf.line(10, 44, 200, 44);
                    pdf.setTextColor(41, 122, 14);
                    pdf.text("TAX INVOICE", 95, 49);
                    pdf.setLineWidth(0.3);
                    pdf.setDrawColor(80, 80, 80);
                    pdf.line(10, 52, 200, 52);
                    pdf.setTextColor(0, 0, 0);

                    let y = 45;
                    pdf.setFontSize(9);
                };

                const addFooter = (pdf) => {
                    const footerY = 285; // bottom of page
                    pdf.setTextColor(0, 0, 0);
                    pdf.setFont("Signika-Medium");
                    pdf.setFontSize(7);
                    pdf.text("Powered by: Sugarian.app", 12, footerY);
                };

                const pageHeight = pdf.internal.pageSize.height;
                const maxRowsPerPage = 10;

                billData.forEach((item, index) => {

                    if (index > 0 && index % maxRowsPerPage === 0) {
                        addFooter(pdf);
                        pdf.addPage();
                        addHeader(pdf);

                        y = 47;
                    }

                    pdf.setFont("Signika-Medium");
                    pdf.setTextColor(0, 0, 0);
                    pdf.text(String(item.itemname ?? "Sugar"), 12, y + 9);
                    pdf.setFont("Signika-Regular");
                    // pdf.text(String(item.millshortname ?? ""), 50, y + 9);
                    pdf.text(String(item.HSN ?? ""), 80, y + 9);
                    pdf.text(String(item.Quantal ?? ""), 100, y + 9);
                    // pdf.text(String(item.season ?? ""), 120, y + 9);
                    const value = parseFloat(item.subTotal || 0);
                    // const rate = parseFloat(item.Quantal)
                    //   ? (value / parseFloat(item.Quantal)).toFixed(2)
                    //   : 0;

                    const formattedQty = Number(item.bags || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                    });
                    const formattedRate = Number(item.salerate).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                    });
                    const formattedValue = Number(item.item_Amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                    });
                    const amountX = 197;
                    const rateX = 170;
                    const labelX = 130;

                    pdf.text(`${formattedQty} ${rawUnit}`, labelX, y + 9,);
                    pdf.text(formattedRate, rateX, y + 9, { align: "right" });
                    pdf.text(formattedValue, amountX, y + 9, { align: "right" });

                    y += 8;
                    pdf.setFont("Signika-Regular");
                });

                // ===== TOTAL ROW =====
                y += 4; // small gap before total


                const addNewPage = () => {

                    pdf.addPage();


                    y = addHeader();
                    drawFieldPairs();


                    addHeader();


                    y += 12;


                    addHeader();
                };

                pdf.setLineWidth(0.3);
                pdf.line(10, y, 200, y); // top line

                y += 5;

                pdf.setFont("Signika-Bold");
                pdf.setTextColor(0, 0, 0);

                // Label
                pdf.text("Total", 12, y);



                // Align exactly with your columns
                pdf.text(`${rowData.NETQNTL}`, 110, y, { align: "right" }); // Unit column
                pdf.text(`${rowData.NETWT}`, 141, y, { align: "right" }); // Rate column (optional use)
                pdf.text(`${rowData.subTotal}`, 197, y, { align: "right" }); // Value column

                y += 4;

                // bottom line
                pdf.line(10, y, 200, y);



                const parseBankDetails = (text = "") => {
                    const bankMatch = text.match(/BANK\s*-\s*(.*?)\s*A\/C\s*NO/i);
                    const acMatch = text.match(/A\/C\s*NO\s*([A-Z0-9]+)/i);
                    const ifscMatch = text.match(/IFSC\s*-\s*([A-Z0-9]+)/i);

                    return {
                        bankName: bankMatch?.[1]?.trim() || "-",
                        acNo: acMatch?.[1]?.trim() || "-",
                        ifsc: ifscMatch?.[1]?.trim() || "-"
                    };
                };

                const bank = parseBankDetails(rowData.companybankdetail);

                let curY = y + 35;

                pdf.setFont("Signika-Bold");
                pdf.setFontSize(10);
                pdf.text("Bank Details:", 12, curY);

                curY += 6;

                pdf.setFont("Signika-Regular");
                pdf.setFontSize(8);

                const labels = ["Bank Name:", "Bank Ac/No:", "IFSC:"];
                const values = [bank.bankName, bank.acNo, bank.ifsc];

                labels.forEach((label, i) => {
                    pdf.text(`${label} ${values[i]}`, 12, curY + (i * 5));

                });
                // const wrappedMillName = pdf.splitTextToSize(String(allData.millname ?? "-"), 90);
                // pdf.text("Mill Name:", 12, y + 11);
                // pdf.text(wrappedMillName, 28, y + 11);
                const amountX = 197;
                const value = parseFloat(rowData.subTotal || 0);
                const rate = parseFloat(rowData.Quantal)
                    ? (value / parseFloat(rowData.Quantal)).toFixed(2)
                    : 0;
                // const millNameHeight = (wrappedMillName.length - 1) * 5;
                let currentY = y + 16;


                let fssai = String(rowData.MillFSSAI_No ?? "").trim();
                if (fssai !== "") {
                    // Manually insert breakable characters every 15 chars if needed
                    if (fssai.length > 25 && !fssai.includes(" ")) {
                        fssai = fssai.match(/.{1,20}/g).join(" ");
                    }

                    const wrappedFSSAI = pdf.splitTextToSize(fssai, 100);
                    pdf.text("Mill FSSAI:", 12, currentY);
                    pdf.text(wrappedFSSAI, 28, currentY);
                }



                y += 8;

                // 1. Parse out your rates / amounts
                const igstRate = parseFloat(rowData.IGSTRate) || 0;
                const igstAmt = parseFloat(rowData.IGSTAmount) || 0;

                const cgstRate = parseFloat(rowData.CGSTRate) || 0;
                const cgstAmt = parseFloat(rowData.CGSTAmount) || 0;

                const sgstRate = parseFloat(rowData.SGSTRate) || 0;
                const sgstAmt = parseFloat(rowData.SGSTAmount) || 0;

                const taxRows = [];

                if (igstRate > 0) {
                    // only IGST
                    taxRows.push(["IGST", igstRate, igstAmt]);
                } else {
                    taxRows.push(
                        ["CGST", cgstRate, cgstAmt],
                        ["SGST", sgstRate, sgstAmt]
                    );
                }

                const summaryFields = [
                    ...(
                        (rowData.carporateSaleDoc === 0 ||
                            rowData.carporateSaleDoc === "" ||
                            rowData.carporateSaleDoc === null) &&
                            parseFloat(rowData.freight) !== 0
                            ? [["Freight", rowData.LESS_FRT_RATE, rowData.freight]]
                            : []
                    ),

                    ["Leavy Amount", "", rowData.LeavyAmt],
                    ["Taxable Amount", "", rowData.TaxableAmount],
                    ...taxRows,
                    ["Rate Diff/Qntl", "", rowData.RateDiff],
                    ["Other Expense", "", rowData.OTHER_AMT],
                    ["Round Off", "", rowData.RoundOff],

                    ...(TCSApplicable === "N"
                        ? []
                        : [
                            ["TCS:", rowData.TCS_Rate, rowData.TCS_Amt],
                            ["TCS Net Payable:", "", rowData.TCS_Net_Payable],
                        ]),
                ];

                summaryFields.forEach(([label, rate, amount]) => {
                    pdf.setFont("Signika-Regular");

                    // Label
                    pdf.text(`${label}:`, 130, y + 3);

                    // // Rate, if available
                    // if (rate !== null && rate !== undefined && rate !== "") {
                    //   pdf.text(`${formatReadableAmount(rate)}/Qntl`, 165, y + 3, { align: "center" });
                    // }


                    let rateLabel = "";

                    // GST rows
                    if (label === "IGST" || label === "CGST" || label === "SGST") {
                        rateLabel = "%";
                    }

                    // Other rows (Freight, RateDiff, Other Expense, TCS, etc.)
                    else {
                        rateLabel = "/KGS";
                    }

                    // Print rate only if exists
                    if (rate !== null && rate !== undefined && rate !== "") {
                        pdf.text(`${formatReadableAmount(rate)}${rateLabel}`, 165, y + 3, { align: "center" });
                    }


                    // Format amount safely
                    const formattedAmount = formatReadableAmount(amount);
                    pdf.text(formattedAmount, 197, y + 3, { align: "right" });

                    y += 5;
                });


                pdf.setLineWidth(0.3);
                pdf.setDrawColor(80, 80, 80);
                pdf.line(10, y + 4, 200, y + 4);


                const totalInWords = ConvertNumberToWord(
                    parseFloat(rowData.TCS_Net_Payable)
                );
                pdf.text(`Rs: ${totalInWords}.`, 12, y + 9);
                const formattedTotal = Number(rowData.TCS_Net_Payable || 0).toLocaleString(
                    "en-IN",
                    {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }
                );

                pdf.setFont("Signika-Bold");
                pdf.setTextColor(41, 122, 14);
                pdf.text("Total Amount:", 150, y + 9);
                pdf.text(`₹ ${formattedTotal}`, amountX, y + 9, { align: "right" });

                y += 5;
                pdf.setLineWidth(0.3);
                pdf.line(10, y + 7, 200, y + 7);


                const footerY = 285; // Your footer position
                const poweredByY = footerY + 3; // Position of "Powered by" text
                const termsStartY = y + 12; // Where Terms & Conditions would start
                const termsHeight = 25;


                if (termsStartY + termsHeight > poweredByY) {
                    // Add footer to current page
                    addFooter(pdf);

                    // Add new page
                    pdf.addPage();

                    // Reset header on new page
                    addHeader(pdf);

                    // Reset Y position for new page (after header)
                    y = 47; // Adjust based on your header height
                }

                pdf.setFont("Signika-Bold");
                pdf.setTextColor(0, 0, 0);
                pdf.setFontSize(8);
                pdf.text("Terms & Conditions:", 12, y + 12);
                pdf.setFont("Signika-Regular");
                const notes = [
                    "- If there is no insurance of the goods, after dispatch from the destination,",
                    "   we are not responsible for non delivery, damage or any kind of loss.",
                    "- Buyer must inspect and confirm quality & quantity of the goods before dispatch from godown.",
                    "   Once loaded and truck leaves godown, Said all responsibilities will be transfer to buyers account.",
                    "- Please send the full amount in our account through RTGS before despatch the goods.",
                    "   If the amount is not received in our account, Interest of 24% P.A. will be charged to the buyer.",
                    `- Subject to ${rowData.companyCity} jurisdiction.`
                ];
                for (let i = 0; i < notes.length; i++) {
                    const noteY = y + 13 + (i + 1) * 3;

                    // Check if this specific line would exceed page
                    if (noteY > poweredByY - 10) {
                        // Add footer to current page
                        addFooter(pdf);

                        // Add new page
                        pdf.addPage();

                        // Reset header on new page
                        addHeader(pdf);

                        // Reset Y position
                        y = 47;

                        // Draw remaining notes on new page
                        for (let j = i; j < notes.length; j++) {
                            const remainingNoteY = y + 13 + (j - i + 1) * 3;
                            pdf.text(notes[j], 12, remainingNoteY);
                        }

                        // Update y position
                        y += (notes.length - i) * 3 + 25;
                        break;
                    }

                    pdf.text(notes[i], 12, noteY);

                    // If this is the last note, update y position
                    if (i === notes.length - 1) {
                        y += 25;
                    }
                }


                if (rowData.SBNarration) {
                    pdf.text(`${rowData.SBNarration}`, 12, y + 12)
                }
                const signY = y - 10;
                pdf.setFont("Signika-Bold");
                pdf.setFontSize(9);
                pdf.setTextColor(0, 0, 0);
                const forText = `For. ${String(displayCompanyName ?? "")}`;
                const textWidth = pdf.getTextWidth(forText);
                const rightMargin = 197;
                const forTextX = rightMargin - textWidth;

                pdf.text(forText, forTextX, signY);
                const signWidth = 240;
                const signHeight = signWidth / 5;

                y -= 20;

                // pdf.addImage(signImg, "PNG", 157, y + 11, signWidth, signHeight);
                pdf.text("Authorised Signatory", 168, y + 28);

                // const footerY = 252;
                const footerHeight = 37;
                // const poweredByY = footerY + footerHeight + 3;/

                // if(shouldUseImage){
                // pdf.addImage("PNG", 0, footerY, 260, footerHeight);
                // }else{
                //    pdf.addImage("PNG", 0, footerY, 210, footerHeight);
                // }

                pdf.setFont("Signika-Medium");
                pdf.setFontSize(7);
                pdf.setTextColor(0, 0, 0);
                pdf.text("Powered by: Sugarian.app", 12, poweredByY);



                // const pdfBlob = pdf.output("blob");
                // const pdfUrl = URL.createObjectURL(pdfBlob);


                // setPdfPreview({
                //     url: pdfUrl,
                //     data: {
                //         ...rowData,
                //         sale_rate: rate,
                //         Doc_No: `SJ${rowData?.year || ""}-${rowData?.doc_no || ""}`,
                //         CompanyName: displayCompanyName
                //     }
                // });
            };


        };

        const value = parseFloat(allData.subTotal || 0);
        const rate = parseFloat(allData.Quantal)
            ? (value / parseFloat(allData.Quantal)).toFixed(2)
            : 0;
        const displayCompanyName = docDate < cnameUpdatedDate ? newCompanyName : allData.Company_Name_E;

        const pdfBlob = pdf.output("blob");

        if (pdfBlob instanceof Blob) {
            const pdfUrl = URL.createObjectURL(pdfBlob);

            setPdfPreview({
                url: pdfUrl,
                data: {
                    ...allData,
                    sale_rate: rate,
                    Doc_No: `SJ${allData?.year || ""}-${allData?.doc_no || ""}`,
                    CompanyName: displayCompanyName
                }
            });
        }
    }

    const gstNo = sessionStorage.getItem("Company_GSTNO") || "";


    const jkGSTs = [
        "27AAECJ8332R1ZV",
        "27AEJPS9860D1Z0",
        "27ARCPS1606H1ZW",
        "27AAMFJ4182A1ZG",
    ];

    const isJK = jkGSTs.includes(gstNo.toUpperCase());

    let label = ''
    if (isJK) {
        label = "accounts_sale_bill_2"
    }
    else {
        label = "SaleBill"
    }
    // return (
    //     <div id="pdf-content">
    //         {pdfPreview && (
    //             <PdfPreview
    //                 pdfData={pdfPreview.url}
    //                 apiData={pdfPreview.data}
    //                 label={label}
    //             />
    //         )}
    //         <PrintButton disabledFeild={disabledFeild} fetchData={fetchData} label={"Gul Sale Bill Print"} />
    //     </div>
    // );

    return (
        <>
            <div id="pdf-content">

                {/* PDF Preview */}
                {pdfPreview && (
                    <PdfPreview
                        pdfData={pdfPreview.url}
                        apiData={pdfPreview.data}
                        label={label}
                    />
                )}



                {/* Batch Print Button */}
                <PrintButton
                    fetchData={() => setShowBatchPopup(true)}
                    disabledFeild={disabledFeild}
                    label={"Batch Print"}
                />

            </div>

            {/* Popup */}
            {showBatchPopup && (
                <div className="sugar-salebill-modal" role="dialog" style={{ display: "block" }}>
                    <div
                        className="sugar-salebill-modal-dialog"
                        role="document"
                        style={{ width: "400px", margin: "auto" }}
                    >
                        <div className="modal-content">
                            <div className="sugar-salebill-modal-header">
                                <h5><strong>Batch Print</strong></h5>
                                <button onClick={() => setShowBatchPopup(false)}>×</button>
                            </div>

                            <div style={{ padding: "20px" }}>

                                <div style={{ marginBottom: "10px", font: "bold" }}>
                                    <label><strong>From Doc No</strong></label>
                                    <input
                                        type="number"
                                        value={fromDocNo}
                                        onChange={(e) => setFromDocNo(e.target.value)}
                                        style={{ marginLeft: "10px", width: "120px" }}
                                    />
                                </div>

                                <div style={{ marginBottom: "10px" }}>
                                    <label><strong>To Doc No</strong></label>
                                    <input
                                        type="number"
                                        value={toDocNo}
                                        onChange={(e) => setToDocNo(e.target.value)}
                                        style={{ marginLeft: "28px", width: "120px" }}
                                    />
                                </div>

                            </div>

                            <div className="modal-footer">
                                <button onClick={fetchData}>Print</button>
                                <button onClick={() => setShowBatchPopup(false)}>Cancel</button>
                            </div>

                        </div>

                    </div>
                </div>
            )}

        </>
    );
};
export default GulCustomizeSBBatchReport;



